import axios from 'axios';
import { NodeDoneHistoryWire } from './node-done-history.wire';
import { NodeWire } from './node.wire';
import { ServerApiStore } from './server.api.store';

async function getRootNode() {
  const response = await axios.get<NodeWire>('https://api.usemegaboard.com/nodes/root', {
    headers: {
      Authorization: `Bearer ${ServerApiStore.getToken()}`,
    },
  });
  return response.data;
}

async function getTodayNode() {
  const response = await axios.get<NodeWire>('https://api.usemegaboard.com/nodes/today', {
    headers: {
      Authorization: `Bearer ${ServerApiStore.getToken()}`,
    },
  });
  return response.data;
}

async function getNode(id: string) {
  const response = await axios.get<NodeWire>(`https://api.usemegaboard.com/nodes/${id}`, {
    headers: {
      Authorization: `Bearer ${ServerApiStore.getToken()}`,
    },
  });
  return response.data;
}

async function getNodes(ids: string[]) {
  const response = await axios.post<NodeWire[]>(
    'https://api.usemegaboard.com/nodes/get-nodes',
    { ids },
    {
      headers: {
        Authorization: `Bearer ${ServerApiStore.getToken()}`,
      },
    },
  );
  return response.data;
}

async function getNodesAndAllSubNodes(ids: string[]) {
  const response = await axios.post<NodeWire[]>(
    'https://api.usemegaboard.com/nodes/get-nodes-and-all-sub-nodes',
    { ids },
    {
      headers: {
        Authorization: `Bearer ${ServerApiStore.getToken()}`,
      },
    },
  );
  return response.data;
}

async function createNode(node: NodeWire) {
  const response = await axios.post<NodeWire>('https://api.usemegaboard.com/nodes', node, {
    headers: {
      Authorization: `Bearer ${ServerApiStore.getToken()}`,
    },
  });
  return response.data;
}

async function updateNode(id: string, node: Partial<NodeWire>) {
  const response = await axios.put<NodeWire>(`https://api.usemegaboard.com/nodes/${id}`, node, {
    headers: {
      Authorization: `Bearer ${ServerApiStore.getToken()}`,
    },
  });
  return response.data;
}

async function getTodayDoneCount(anchorTimestamp: number): Promise<{ count: number }> {
  const response = await axios.post<{ count: number }>(
    'https://api.usemegaboard.com/nodes/get-today-done-count',
    { anchorTimestamp },
    {
      headers: {
        Authorization: `Bearer ${ServerApiStore.getToken()}`,
      },
    },
  );
  return response.data;
}

async function createNodeDoneHistory(nodeDoneHistory: Partial<NodeDoneHistoryWire>): Promise<NodeDoneHistoryWire> {
  const response = await axios.post<NodeDoneHistoryWire>('https://api.usemegaboard.com/node-done-histories', nodeDoneHistory, {
    headers: {
      Authorization: `Bearer ${ServerApiStore.getToken()}`,
    },
  });
  return response.data;
}

async function textToDate({
  text,
  referenceDate,
  startingWeek,
}: {
  text: string;
  referenceDate: number;
  startingWeek: 'mon' | 'sun';
}): Promise<{ date: string }> {
  const response = await axios.post<{ date: string }>(
    'https://api.usemegaboard.com/agent/text-to-date',
    { text, referenceDate, startingWeek },
    {
      headers: {
        Authorization: `Bearer ${ServerApiStore.getToken()}`,
      },
    },
  );
  return response.data;
}

export const ServerApi = {
  getRootNode,
  getTodayNode,
  getNode,
  getNodes,
  getNodesAndAllSubNodes,
  createNode,
  updateNode,
  getTodayDoneCount,
  createNodeDoneHistory,
  textToDate,
};
